export default "__VITE_ASSET__DZs9jb$v__"